import { graphql } from "gatsby"
import React from "react"
// import { Link } from "gatsby"
import { Hero } from "../components/hero"
import { getImage } from "gatsby-plugin-image"
import Layout from "../components/layout"
import Seo from "../components/seo"

const ContactPage = ({ data }) => {
  // data prop is passed in automatically from the 'query' var on line 46 - this only works on 'pages' though, there's a different setup for components
  const heroImage = getImage(data.heroImage)

  return (
    <Layout page="contact">
      <Seo title="Contact" />
      <Hero image={heroImage} title="Contact" />

      <div className="container" id="contact-area">
        <strong>
          <p>LUMBEROB</p>
        </strong>
        <p><a href="mailto:lumberob@gmail.com">lumberob@gmail.com</a></p>
        <strong>
          <p>For All LUMBEROB Related Press Inquiries Please Contact</p>
        </strong>
        <p>Kip Kouri - <a target="_blank" rel="noreferrer nofollow" href="mailto:kip@tellallyourfriendspr.com">kip@tellallyourfriendspr.com</a></p>
        <p>Erin Christie - <a target="_blank" rel="noreferrer nofollow" href="mailto:erin@tellallyourfriendspr.com">erin@tellallyourfriendspr.com</a></p>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    heroImage: imageSharp(resize: { originalName: { eq: "lumber-home.jpg" } }) {
      gatsbyImageData(width: 2791)
    }
  }
`

export default ContactPage
